import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

function Input({
  label,
  name,
  placeholder,
  type = "text",
  icon: Icon,
  value,
  onChange,
  disabled = false,
  required = true,
  hint = null,
}) {
  const [showPassword, setShowPassword] = useState(false);

  const isPassword = type === "password";

  return (
    <div>
      <label className="mb-1.5 block text-[11px] font-semibold text-gray-700">
        {label}

        {required && (
          <span className="ml-1 text-red-500">*</span>
        )}
      </label>

      <div className="relative">
        {Icon && (
          <Icon
            size={15}
            className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
          />
        )}

        <input
          type={
            isPassword
              ? showPassword
                ? "text"
                : "password"
              : type
          }
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          className={[
            "h-10 w-full rounded-lg border border-gray-200 bg-white text-xs text-gray-800 outline-none transition-all placeholder:text-gray-400",
            Icon ? "pl-9" : "pl-3",
            isPassword ? "pr-10" : "pr-3",
            "focus:border-[#00a884] focus:ring-2 focus:ring-[#00a884]/10",
            "disabled:cursor-not-allowed disabled:bg-gray-100",
          ].join(" ")}
        />

        {isPassword && (
          <button
            type="button"
            onClick={() =>
              setShowPassword((value) => !value)
            }
            disabled={disabled}
            className="absolute right-2.5 top-1/2 -translate-y-1/2 rounded-md p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600 disabled:opacity-50"
          >
            {showPassword ? (
              <EyeOff size={14} />
            ) : (
              <Eye size={14} />
            )}
          </button>
        )}
      </div>

      {hint && (
        <p className="mt-1 text-[10px] leading-4 text-gray-500 dark:text-dark-text-muted">
          {hint}
        </p>
      )}
    </div>
  );
}

export default Input;